import React from 'react'

import Posts from './Components/Posts'
import Cover from './Components/Cover'
import PostsSimple from './Components/PostsSimple'
import TextField from './Components/TextField'

import Text from 'karrierhub-ui/dist/common/src/components/Input/Text'
import Checkbox from 'karrierhub-ui/dist/common/src/components/Input/Checkbox'
import Select from 'karrierhub-ui/dist/common/src/components/Input/Select'
import Switch from 'karrierhub-ui/dist/common/src/components/Input/Switch'

import DefaultSubmit from './Components/DefaultSubmit'

export const defaultComponents = {
    Button: {
        props: {
            ContainerProps: undefined,
            Container: undefined,
            Component: 'button',
            className: '',
            type: 'submit',
            variant: 'contained',
            color: 'primary',
            children: 'Submit',
            disabled: false,
            startIcon: null,
            endIcon: null,
            size: 'default',
            fullWidth: false,
            TypographyProps: undefined,
            tabIndex: undefined,
            LabelComponent: undefined
        },
        Component: DefaultSubmit
    },
    Posts: {
        props: {
            label: '',
            thereAreNoEntriesMessage: 'There are not entries',
            value: '',
            refPostType: 'post',
            multiple: false,
            disabled: false,
            enableNew: false,
            enableNewInDialog: false,
            NewComponent: null,
            NewComponentProps: undefined,
            accept: '',
            disableFindByAuthor: false,
            type: '',
            initialMaxPerPage: false,
            disableTable: true,
            helperText: '',
            error: false,
            errorMessage: '',
            needErrorUpdate: undefined,
            author: null,
            propKey: '',
            validation: null,
            placeholder: undefined,
            PostsListProps: undefined,
            DialogPostsProps: undefined,
            copyPostToStore: undefined,
            SelectComponentProps: undefined
        },
        Component: Posts
    },
    PostsSimple: {
        props: {
            label: '',
            thereAreNoEntriesMessage: 'There are not entries',
            value: '',
            refPostType: 'post',
            multiple: false,
            disabled: false,
            type: '',
            disableTable: true,
            helperText: '',
            error: false,
            errorMessage: '',
            needErrorUpdate: undefined,
            propKey: '',
            validation: null,
            placeholder: undefined,
            PostsListProps: undefined,
            disableThumbnails: undefined,
            disableAvatars: undefined,
            copyPostToStore: undefined
        },
        Component: PostsSimple
    },
    Cover: {
        props: {
            label: '',
            thereAreNoEntriesMessage: 'There are not entries',
            value: '',
            refPostType: 'post',
            disabled: false,
            enableNew: false,
            enableNewInDialog: false,
            NewComponent: null,
            NewComponentProps: undefined,
            accept: '',
            disableFindByAuthor: false,
            initialMaxPerPage: false,
            disableTable: true,
            helperText: '',
            error: false,
            errorMessage: '',
            needErrorUpdate: undefined,
            author: null,
            propKey: '',
            cropPropName: '',
            formData: null,
            formActions: null,
            validation: null,
            placeholder: undefined,
            maskHeightPercent: undefined
        },
        Component: Cover
    },
    TextField: {
        props: {
            className: '',
            type: 'text',
            label: '',
            value: '',
            error: false,
            errorMessage: '',
            needErrorUpdate: undefined,
            helperText: '',
            variant: 'contained',
            autoComplete: 'on',
            disabled: false,
            multiline: false,
            minRows: null,
            maxRows: null,
            placeholder: '',
            size: 'default',
            validation: null,
            HelperTextComponent: null,
            startIcon: null,
            endIcon: null,
            onBlur: null,
            transformValue: undefined,
            enableUpdateValueAfterTransform: undefined,
            onKeyDown: undefined
        },
        Component: TextField
    },
    Checkbox: {
        props: {
            className: '',
            label: '',
            value: false,
            error: false,
            errorMessage: '',
            needErrorUpdate: undefined,
            helperText: '',
            variant: 'contained',
            disabled: false,
            size: 'default',
            startIcon: null,
            endIcon: null,
            validation: null
        },
        Component: ({ label, value, onChange, id, ...props }) => {

            return <Checkbox
                ContainerProps={{
                    name: id
                }}
                {...props}
                value={[value]}
                transformValue={(value) => value && Array.isArray(value) ? (!!(value[0]) || false) : (!!(value) || false)}
                InputProps={{
                    /*getCheckboxIconButtonProps: ({ active, disabled, color }) => {
                        return { color: disabled ? 'disabled' : active ? 'primary' : color }
                    },*/
                    menu: [
                        { label: label, value: true }
                    ],
                    onBlur: async (e, value) => {
                        if (e?.target) {
                            e.target.value = !!(value)
                        } else {
                            e = {
                                target: {
                                    value: !!(value)
                                }
                            }
                        }
                        if (onChange) {
                            await onChange(e, !!(value))
                        }
                    },
                    id
                }}
            />
        }
    },
    Switch: {
        props: {
            className: '',
            label: '',
            value: false,
            error: false,
            errorMessage: '',
            needErrorUpdate: undefined,
            helperText: '',
            variant: 'contained',
            disabled: false,
            size: 'default',
            startIcon: null,
            endIcon: null,
            switchIconToEnd: true
        },
        Component: ({ label, value, onChange, id, switchIconToEnd, ...props }) => {

            return <Switch
                ContainerProps={{
                    name: id
                }}
                {...props}
                value={[value]}
                InputProps={{
                    switchIconToEnd,
                    /*getSwitchIconButtonProps: ({ active, disabled, color }) => {
                        return { color: disabled ? 'disabled' : active ? 'primary' : color }
                    },*/
                    menu: [
                        { label: label, value: true }
                    ],
                    onBlur: async (e, value) => {
                        if (e?.target) {
                            e.target.value = !!(value[0])
                        } else {
                            e = {
                                target: {
                                    value: !!(value[0])
                                }
                            }
                        }
                        if (onChange) {
                            await onChange(e, !!(value[0]))
                        }
                    },
                    id
                }}
            />
        }
    },
    Select: {
        props: {
            options: [],
            multiple: false,
            required: false,
            defaultValue: undefined,

            className: '',
            label: '',
            value: '',
            error: false,
            errorMessage: '',
            needErrorUpdate: undefined,
            helperText: '',
            variant: 'contained',
            disabled: false,
            size: 'default',
            placeholder: '',
            startIcon: null,
            endIcon: null,
            InputProps: {},
            MenuComponentProps: {}
        },
        Component: ({
                        label,
                        value,
                        defaultValue,
                        onChange,
                        id,
                        options = [],
                        multiple,
                        placeholder,
                        InputProps = {},
                        ...props
                    }) => {

            return <Select
                label={label}
                ContainerProps={{
                    name: id
                }}
                {...props}
                value={(!value ? typeof defaultValue !== 'undefined' ? [defaultValue] : [] : multiple ? [...value] : [value]).map((p) => p?._id || p)}
                {...!multiple ? { transformValue: (value) => value && value[0] || null } : {}}
                InputProps={{
                    ...InputProps,
                    multiple,
                    placeholder,
                    menu: [
                        ...options
                    ],
                    onBlur: async (e, value) => {
                        if (onChange) {
                            await onChange(e, value)
                        }
                    },
                    id
                }}
            />
        }
    },
    NumberField: {
        props: {
            className: '',
            type: 'text',
            label: '',
            value: '',
            error: false,
            errorMessage: '',
            needErrorUpdate: 0,
            helperText: '',
            variant: 'contained',
            autoComplete: 'on',
            disabled: false,
            placeholder: '',
            size: 'default',
            startIcon: null,
            endIcon: null,
            transformValue: undefined,
            enableUpdateValueAfterTransform: undefined,
            ContainerProps: undefined
        },
        Component: ({ type, value, autoComplete, placeholder, onBlur, id, InputProps = {}, ...props }) => {

            const isValid = (typeof value === 'string' && value && !isNaN(Number(value))) || typeof value === 'number'

            if (!isValid) {
                value = ''
            }

            if (typeof value === 'number') {
                value = value.toString()
            }

            async function _onChange(e, value, _value, handler = 'onChange') {

                const isEmptyString = typeof value === 'string' && !value
                value = value.replace(/ /g, '')
                value = value.replace(/,/g, '.')
                value = (!isEmptyString && !isNaN(Number(value))) ? Number(value) : value

                if (props[handler]) {
                    if (e?.target) {
                        e.target.value = value
                    } else {
                        e = {
                            target: {
                                value
                            }
                        }
                    }
                    await props[handler](e, value)
                }
            }

            return <Text
                ContainerProps={{
                    name: id
                }}
                {...props}
                value={value}
                InputProps={{
                    ...InputProps,
                    ...!onBlur ?
                        {
                            onBlur:
                            _onChange
                        } :
                        {
                            onBlur: async (e, value, _value) => _onChange(e, value, _value, 'onBlur'),
                            onChange: _onChange
                        },
                    id,
                    type: 'number',
                    autoComplete,
                    placeholder
                }}
            />
        }
    }
}
